import script from "./infoModalSolicitudTraslado.vue?vue&type=script&setup=true&lang=js"
export * from "./infoModalSolicitudTraslado.vue?vue&type=script&setup=true&lang=js"

import "./infoModalSolicitudTraslado.vue?vue&type=style&index=0&id=74ebcda2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ebcda2"]])

export default __exports__